import { render, staticRenderFns } from "./ConsumeBitacora.vue?vue&type=template&id=06823e2f&scoped=true&"
import script from "./ConsumeBitacora.vue?vue&type=script&lang=js&"
export * from "./ConsumeBitacora.vue?vue&type=script&lang=js&"
import style0 from "./ConsumeBitacora.vue?vue&type=style&index=0&id=06823e2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06823e2f",
  null
  
)

export default component.exports